import { t } from "@lingui/macro";
import { UiSpinner, UiTypography } from "@smp/ui";
import { dataArrayShuffle } from "@smp/utils";
import { FC, useMemo } from "react";

import { EStep } from "../../create_form.types";
import classes from "./preloader.module.css";

export interface IPreloaderProps {
  step: EStep;
}

const getText = (step: EStep): string => {
  const arr = {
    [EStep.OCCUPATION]: [
      t`AI SMM assistant is studying your business…`,
      t`AI SMM assistant is selecting a relevant audience…`,
      t`AI SMM assistant studies socio-demographic factors…`,
    ],
    [EStep.TARGET_AUDIENCE]: [
      t`AI SMM assistant analyzes what is important for your audience…`,
      t`AI SMM assistant explores the pain and interests of your audience…`,
      t`AI SMM assistant collects data and forms the answer…`,
    ],
    [EStep.PROBLEM]: [t`AI SMM assistant is the final result…`],
    [EStep.CONFIRMATION]: [],
  }[step];

  return dataArrayShuffle(arr).at(0) || "";
};

export const Preloader: FC<IPreloaderProps> = ({ step }) => {
  const text = useMemo(() => getText(step), [step]);

  if (!text) {
    return null;
  }

  return (
    <div className={classes.container}>
      <UiSpinner size={20} />
      <UiTypography variant="body2" className={classes.text}>
        {text}
      </UiTypography>
    </div>
  );
};
